// src/services/api/userApi.js
import { rootApi } from './rootApi';

export const userApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    validateSession: build.query({
        query: () => 'accounts/validateSession',
        keepUnusedDataFor: 900, // 15 minutes cache
        providesTags: () => [{ type: 'User', id: 'VALIDATE_SESSION' }],
    }),
    signIn: build.mutation({
        query: (body) => ({
            url: 'accounts/signin',
            method: 'POST',
            body,
        }),
        invalidatesTags: [{ type: 'User', id: 'USER_SESSION' }],
    }),
    signUp: build.mutation({
        query: (body) => ({
            url: 'accounts/signup',
            method: 'POST',
            body,
        }),
        invalidatesTags: [{ type: 'User', id: 'USER_SUBSCRIPTION' }],
    }),
    resetPassword: build.mutation({
        query: (body) => ({
            url: 'accounts/resetpassword',
            method: 'POST',
            body,
        }),
    }),
    confirmPassReset: build.mutation({
        query: (body) => ({
            url: 'accounts/confirmpass',
            method: 'POST',
            body,
        }),
    }),
    getEmailNotiStatus: build.query({
        query: () => 'app/email-sub-status',
        keepUnusedDataFor: 300, // 5 minutes cache
        providesTags: () => [{ type: 'User', id: 'EMAIL_NOTIFICATIONS' }],
    }),
    unsubscribeEmail: build.mutation({
        query: () => ({
            url:'app/unsub-email',
            method: 'GET',
        }),
        invalidatesTags: [{ type: 'User', id: 'EMAIL_NOTIFICATIONS' }],
    }),
    subscribeEmail: build.mutation({
        query: () => ({
            url: 'app/subscribe-email',
            method: 'GET',
        }),
        invalidatesTags: [{ type: 'User', id: 'EMAIL_NOTIFICATIONS' }],
    }),
    getUserSubscription: build.query({
        query: () => ({
            url: 'payments/get-subscription',
            method: 'POST',
            body: {},
        }),
        keepUnusedDataFor: 900, // 15 minutes cache
        providesTags: [{ type: 'User', id: 'USER_SUBSCRIPTION' }],
    }),
    createCustomerPortalSession: build.mutation({
        query: (body) => ({
            url: 'payments/customer-portal',
            method: 'POST',
            body,
        }),
        invalidatesTags: [{ type: 'User', id: 'USER_SUBSCRIPTION' }],
    }),
    getUserSession: build.query({
        query: () => 'accounts/userSession',
        keepUnusedDataFor: 900, // 15 minutes cache
        providesTags: () => [{ type: 'User', id: 'USER_SESSION' }],
    }),
    logout: build.mutation({
        query: () => ({
            url: 'accounts/logout',
            method: 'GET',
        }),
        invalidatesTags: ['User'],
    }),
  }),
  overrideExisting: false,
});

export const {  
    useValidateSessionQuery,
    useSignInMutation,
    useSignUpMutation,
    useResetPasswordMutation,
    useConfirmPassResetMutation,
    useGetEmailNotiStatusQuery,
    useUnsubscribeEmailMutation,
    useSubscribeEmailMutation,
    useGetUserSubscriptionQuery,
    useCreateCustomerPortalSessionMutation,
    useGetUserSessionQuery,
    useLogoutMutation,
} = userApi;